import './detailsSection.scss';
import {useSearchPageType, useSelectedDocContext} from '../../../search-hooks';
import React from 'react';
import {HibuTagList} from './tag-list/hibuTagList';
import {deleteTag, upsertTag} from '../../../../services/manual-validation-service';
import {useDispatch} from 'react-redux';
import {HibuTag, Span, TagUpdate} from '../../../search-types';
import {useSpotlightTagTypes} from '../../../../config/config-hooks';
import {AggregationList} from './aggregation-list/aggregationList';
import {DuplicatesList} from './duplicates-list/duplicatesList';
import {BaseDataRow} from './base-data-list/baseDataRow';
import {MetadataList} from './metadata-list/metadataList';
import {useStateTechnicalDetails} from '../../../../settings/duck/settings-hooks';

export const DetailsSection = (): React.JSX.Element | null => {
    const searchPageType = useSearchPageType();
    const doc = useSelectedDocContext();
    const dispatch = useDispatch();
    const spotlightTagTypes = useSpotlightTagTypes();
    const showTechnicalDetails = useStateTechnicalDetails();
    const {heading, ...aggregationsWithoutHeadings} = doc?.aggregations ?? {};

    if (!doc) {
        return null;
    }

    const removeTag = (tagCategory: string, tag: HibuTag) => {
        const updatedTag: TagUpdate = {
            tagType: tagCategory,
            tagId: tag.id,
            labels: null,
            extra: null,
        };
        const action = deleteTag(searchPageType, doc, updatedTag);
        dispatch(action);
    };

    const changeTag = (
        tagCategory: string,
        tag: HibuTag,
        labels: {[language: string]: string} | null,
        extra: {[key: string]: any} | null,
        spans?: Span[],
        updatedTagId?: string | null,
    ) => {
        const updatedTag: TagUpdate = {
            tagType: tagCategory,
            tagId: updatedTagId ?? tag.id,
            labels: labels,
            extra: extra,
            spans: spans,
        };
        const action = upsertTag(searchPageType, doc, updatedTag);
        dispatch(action);
    };

    const addTag = (
        tagCategory: string,
        tagId: string | null,
        labels: {[language: string]: string} | null,
        extra: {[key: string]: any} | null,
    ) => {
        const tag: TagUpdate = {
            tagType: tagCategory,
            tagId: tagId,
            labels: labels,
            extra: extra,
        };
        const action = upsertTag(searchPageType, doc, tag);
        dispatch(action);
    };

    const filteredHibuTagList = {...doc.hibuTags};
    // filter out all tagTypes, that are already displayed in the spotlight tab
    spotlightTagTypes
        .map((stt) => stt.name)
        .forEach((stt) => stt in filteredHibuTagList && delete filteredHibuTagList[stt]);

    return (
        <>
            {showTechnicalDetails && <BaseDataRow/>}
            <MetadataList/>
            <HibuTagList filteredDocumentTags={filteredHibuTagList} removeTag={removeTag} changeTag={changeTag}
                         addTag={addTag}/>
            <AggregationList aggregations={aggregationsWithoutHeadings}/>
            {doc.duplicates && doc.duplicates.length > 0 && (<DuplicatesList duplicates={doc.duplicates}/>)}
        </>
    );
};
